import request from '../request';

// type 1:关于我们  2：联系我们 3：版权声明 4：帮助中心
export function getFootByType(params) {
    return request('/foot/getFootByType', {
        method: 'GET',
        params
    });
}
